module.exports = {
	"graphqlEndpoint": "https://nuefclyjtrhpvnxzrt7kroovd4.appsync-api.ap-southeast-2.amazonaws.com/graphql",
	"region": "ap-southeast-2",
	"authenticationType": "API_KEY",
	"apiKey": "da2-v6xiqrsi3vfmhpircg64jcdo5i"
};


//////////////////
// WEBPACK FOOTER
// ./src/app-sync/AppSync.json
// module id = 351
// module chunks = 1